import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionLightConditionPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-plant-location-type')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionLightCondition.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionLightCondition.brightDirect'),
          value: 'bright_direct',
        },
        {
          text: t('pages.onboarding.questionLightCondition.brightIndirect'),
          value: 'bright_indirect',
        },
        {
          text: t('pages.onboarding.questionLightCondition.mediumLight'),
          value: 'medium_light',
        },
        {
          text: t('pages.onboarding.questionLightCondition.lowLight'),
          value: 'low_light',
        },
        {
          text: t('pages.onboarding.questionLightCondition.notSure'),
          value: 'not_sure',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
